import(/* webpackMode: "eager" */ "/home/runner/work/captivateclick-next/captivateclick-next/src/app/error.tsx");
